<template>
  <el-row>
    <el-row>
      <template v-for="(form, idx) in forms">
        <el-col :span="12" :key="idx">
          <el-form-item
            v-if="idx === 0 || idx === 1"
            size="small"
            :prop="form.id"
            :label="form.label"
            :rules="form.rules"
          >
            <el-col :span="12">
              <el-input
                v-model="AdminAndStaff[form.id]"
                :type="form.type"
                :placeholder="`Please input ${form.label}`"
              ></el-input>
            </el-col>
          </el-form-item>
        </el-col>
      </template>
    </el-row>

    <el-row>
      <el-col :span="12">
        <template v-for="(form, idx) in forms">
          <el-form-item
            v-if="idx >= 2 && idx <=4"
            :key="idx"
            size="small"
            :prop="form.id"
            :label="form.label"
            :rules="form.rules"
          >
            <el-col :span="12">
              <el-input
                v-if="form.type == 'text' || form.type == 'email' || form.type == 'number'"
                v-model="AdminAndStaff[form.id]"
                :type="form.type"
                :placeholder="`Please input ${form.label}`"
              ></el-input>
            </el-col>
          </el-form-item>
        </template>
      </el-col>
    </el-row>

    <el-row>
      <template v-for="(form, idx) in forms">
        <el-col :span="12" :key="idx">
          <el-form-item
            v-if="idx === 5 || idx === 7 || idx === 6 && AdminAndStaff['userType'] === 'administrator'"
            size="small"
            :prop="form.id"
            :label="form.label"
            :rules="form.rules"
          >
            <el-col :span="12">
              <el-select
                v-if="form.type == 'select'"
                v-model="AdminAndStaff[form.id]"
                :placeholder="`Please select ${form.label}`"
                style="width: 100%"
                filterable
                remote
                :remote-method="onSearchBranch"
                :loading="branchs.isLoading"
              >
                <el-option
                  v-for="item in form.data"
                  :key="item.value"
                  :label="item.name"
                  :value="item.value"
                ></el-option>
                <el-row type="flex" justify="center">
                  <el-button
                    :loading="branchs.isLoading"
                    size="mini"
                    round
                    @click="loadMoreBranch"
                  >Load More</el-button>
                </el-row>
              </el-select>
            </el-col>
          </el-form-item>
        </el-col>
      </template>
    </el-row>
    <el-row>
      <el-col :span="12">
        <el-form-item
          v-if="AdminAndStaff['userType'] === 'sales'"
          size="small"
          :prop="forms[8].id"
          :label="forms[8].label"
          :rules="forms[8].rules"
        >
          <el-col :span="12">
            <el-select
              v-if="forms[8].type == 'select'"
              v-model="AdminAndStaff[forms[8].id]"
              :placeholder="`Please select ${forms[8].label}`"
              style="width: 100%"
              filterable
              remote
              :remote-method="onSearchOwner"
              :loading="customers.isLoading"
            >
              <el-option
                v-for="item in forms[8].data"
                :key="item.name"
                :label="item.name"
                :value="item.value"
              ></el-option>
              <el-row type="flex" justify="center">
                <el-button
                  :loading="customers.isLoading"
                  size="mini"
                  round
                  @click="loadMoreCustomer"
                >Load More</el-button>
              </el-row>
            </el-select>
          </el-col>
        </el-form-item>
      </el-col>
    </el-row>
    <el-row>
      <el-col>
        <el-form-item label="Status" prop="active">
          <el-switch v-model="AdminAndStaff.isActive"></el-switch>
        </el-form-item>
      </el-col>
    </el-row>
  </el-row>
</template>

<script>
import { mapActions, mapState } from "vuex";
export default {
  props: ["AdminAndStaff", "from"],
  data() {
    return {
      form: {
        search: ""
      },
      limitBranch: 25,
      limitCustomer: 25,
      searchBranch: '',
      searchOwner: ''
    };
  },
  methods: {
    ...mapActions({
      getBranchs: "branch/GetBranchs",
      deleteBranch: "branch/DeleteBranch",
      getOwners: "customer/GetOwners",
    }),
    onSearchBranch(search) {
      this.searchBranch = search;
      let option = {
        params: {
          page: 1,
          limit: 25,
          search: search
        }
      };
      this.getBranchs(option);
    },
    onSearchOwner(search) {
      this.searchOwner = search;
      let option = {
        params: {
          page: 1,
          limit: 25,
          search: search
        }
      };
      this.getOwners(option);
    },
    loadMoreBranch() {
      this.limitBranch += 25;
      let option = {
        params: {
          page: 1,
          limit: this.limitBranch,
          search: this.searchBranch
        }
      };
      this.getBranchs(option);
    },
    loadMoreCustomer() {
      this.limitCustomer += 25;
      let option = {
        params: {
          page: 1,
          limit: this.limitCustomer,
          search: this.searchOwner
        }
      };
      this.getOwners(option);
    }
  },
  computed: {
    forms() {
      return [
        {
          type: "text",
          id: "username",
          label: "NIK",
          rules: [
            {
              required: true,
              message: "NIK is required",
              trigger: "blur"
            }
          ]
        },
        {
          type: "password",
          id: "password",
          label: "Password",
          rules:
            this.from !== "edit"
              ? [
                {
                  required: true,
                  message: "Password is required",
                  trigger: "blur"
                }
              ]
              : []
        },
        {
          type: "text",
          id: "fullname",
          label: "Nama",
          rules: [
            { required: true, message: "Name is required", trigger: "blur" }
          ]
        },
        {
          type: "email",
          id: "email",
          label: "Email",
          rules: [
            { required: true, message: "Email is required", trigger: "blur" }
          ]
        },
        {
          type: "text",
          id: "jobTitle",
          label: "Jabatan",
          rules: []
        },
        {
          type: "select",
          id: "userType",
          label: "User Type",
          rules: [],
          data: [
            {
              name: "Sales",
              value: "sales"
            },
            {
              name: "Driver",
              value: "driver"
            },
            {
              name: "Management",
              value: "management"
            },
            {
              name: "Administrator",
              value: "administrator"
            }
          ]
        },
        {
          type: "select",
          id: "roleId",
          label: "Role Type",
          rules: [],
          data: [
            {
              name: "Admin BM",
              value: 2
            },
            {
              name: "KU AR",
              value: 6
            },
            {
              name: "Kasir",
              value: 7
            },
            {
              name: "Superadmin",
              value: 1
            }
          ]
        },
        {
          type: "select",
          id: "branchCode",
          label: "Branch",
          rules: [],
          data: this.branchs.data
            ? this.branchs.data.map(item => {
              item.name = `${item.branchCode} - ${item.branch}`;
              item.value = item.branchCode;
              return item;
            })
            : []
        },
        {
          type: "select",
          id: "primarySalesrepId",
          label: "Sales ref",
          rules: [],
          data: this.customers.data
            ? this.customers.data.map(item => {
              item.name = `${item.primarySalesrepId} - ${item.customerName}`;
              item.value = item.primarySalesrepId;
              return item;
            })
            : []
        }
      ];
    },
    ...mapState({
      branchs: state => state.branch.branchs,
      customers: state => state.customer.customers
    })
  },
  created() {
    let option = {
      params: {
        page: 1,
        limit: 25
      }
    };
    this.getBranchs(option);
    this.getOwners(option);
  }
};
</script>

<style>
</style>
